import { FC, useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/data/context/authContext";
import DashboardSidebar from "./DashboardSidebar";
import DashboardHeader from "./DashboardHeader";
import ROUTES from "@/data/Routes";
import Loading from "@/components/Loading";
import { X } from "lucide-react";

const ADMIN_DASHBOARD_PATHS = new Set<string>([
  ROUTES.DASHBOARD,
  ROUTES.RESULTS,
  ROUTES.CONNECTIVITY,
]);

const DashboardLayout: FC = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (isSidebarOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
    }

    return () => {
      document.documentElement.style.overflow = "";
    };
  }, [isSidebarOpen]);

  if (user === undefined) {
    return (
      <div className="bg-sand flex min-h-screen items-center justify-center">
        <Loading className="mt-20" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (ADMIN_DASHBOARD_PATHS.has(pathname) && !user.isAdmin) {
    return <Navigate to={ROUTES.ACCOUNT} replace />;
  }

  // if (
  //   !user.email_verified_at ||
  //   (user.role === ROLES.USER &&
  //     (!user.type_form_submitted || productToRegisterFor))
  // ) {
  //   return <Navigate to={ROUTES.REGISTER} replace />;
  // }

  return (
    <div className="bg-sand flex min-h-screen">
      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-40 transform transition-transform duration-300 md:relative md:flex md:min-h-full md:flex-col md:translate-x-0 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Close button inside sidebar (mobile only) */}
        <button
          onClick={() => setIsSidebarOpen(false)}
          className="absolute top-4 right-4 z-50 rounded-lg bg-white p-2 shadow-lg md:hidden"
          aria-label="Close menu"
        >
          <X className="h-6 w-6 text-gray-700" />
        </button>

        <DashboardSidebar />
      </div>

      {/* Main content area */}
      <div className="flex flex-1 flex-col">
        <DashboardHeader onMenuClick={() => setIsSidebarOpen(true)} />

        {/* Page content */}
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
